import Vue from 'vue'
/**
 * 跳转去双机位监考小程序
 * @param {boolean} isDev
 * @returns
 */
export const goProctotingMini = ({ isDev, examType, recordInterval }) => {
  if (!window.location.search) {
    Vue.prototype.$message.info('参数错误')
    return
  }

  const query = window.location.search.split('?')[1]
  const queryObj = query.split('&').reduce((acc, cur) => {
    const [key, value] = cur.split('=')
    acc[key] = value
    return acc
  }, {})
  if (!queryObj.key) {
    Vue.prototype.$message.info('参数错误')
    return
  }
  const schemeUrl = generateProctoringMiniScheme({ key: queryObj.key, isDev, examType, recordInterval })
  window.location.href = schemeUrl
}

/**
 * 生成监考小程序scheme
 * @param {string} key
 * @param {boolean} isDev
 * @returns
 */
export const generateProctoringMiniScheme = ({ key, isDev }) => {
  const isProd = window.CONFIG.env === 'production'
  let envVersion = isDev ? 'trial' : 'release'
  if (isProd) {
    envVersion = 'release'
  }

  return `weixin://dl/business/?appid=wxe4db96436318d03f&path=pages/index/index&query=${encodeURIComponent(
    'key=' + key
  )}&env_version=${envVersion}`
}
